export default __webpack_public_path__ + "static/media/Icon=Designations.83f5dc01.svg";